import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xl font-bold mb-4">Skepa</h3>
            <p className="text-secondary text-sm">
              Building innovative software solutions for the future.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-secondary hover:text-light transition duration-300">Home</Link></li>
              <li><Link to="/projects" className="text-secondary hover:text-light transition duration-300">Projects</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Projects</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://github.com/AayushMainali-Github/skepa-lang" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-light transition duration-300">Skepa-Lang</a></li>
              <li><a href="https://github.com/AayushMainali-Github/skepa-db" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-light transition duration-300">Skepa-DB</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <p className="text-secondary text-sm">
              Project-specific links are listed above.
            </p>
          </div>
        </div>
        <div className="border-t border-secondary mt-8 pt-8 text-center text-sm text-secondary">
          <p>&copy; 2024 Skepa. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
